<span class="fi-switch" [class.fi-switch--disabled]="disabled">
  <input
    type="checkbox"
    role="switch"
    class="fi-switch__input"
    [checked]="checked"
    [disabled]="disabled"
    [attr.required]="required ? '' : null"
    [attr.aria-label]="ariaLabel || null"
    [attr.aria-labelledby]="ariaLabelledby || null"
    (change)="onInputChange($event)"
  >
  <span class="fi-switch__track" aria-hidden="true"></span>
</span>
